module.exports = __webpack_public_path__ + "img/21_42.30adec27.png";